import React, { useState } from 'react';
import '../style/reviewCard.css';

import star_icon from '../../../assets/icons/star_fill.svg';
import star_icon_empty from '../../../assets/icons/star_notfill.svg';
import arrow_right from '../../../assets/icons/right_arrow.svg';

import formatDate from '../../../utils/formatDate';

const ReviewCard = ({ user_name, created_at, rating, text }) => {
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        setExpanded((prev) => !prev);
    };

    return (
        <div className="review-card">
            <div className="review-header">
                <span className="review-name">{user_name}</span>
                <span className="review-date">{formatDate(created_at)}</span>
            </div>

            <div className="review-stars">
                {[...Array(5)].map((_, i) => (
                    <img
                        key={i}
                        src={i < rating ? star_icon : star_icon_empty}
                        alt="star"
                        className="star-icon"
                    />
                ))}
            </div>

            {text && (
                <p className="review-text">
                    {expanded ? text : text.slice(0, 200) + (text.length > 200 ? '...' : '')}
                </p>
            )}

            {text && text.length > 200 && (
                <button className="review-button" onClick={handleToggle}>
                    <span>{expanded ? 'Свернуть' : 'Подробнее'}</span>
                    <img
                        src={arrow_right}
                        alt="arrow"
                        className={`arrow-icon ${expanded ? 'rotated' : ''}`}
                    />
                </button>
            )}
        </div>
    );
};

export default ReviewCard;